enum HyperlinkTargetEnum {
	self = '_self',
	blank = '_blank',
	parent = '_parent',
	top = '_top'
}
export default HyperlinkTargetEnum;
